export default __webpack_public_path__ + "static/media/hector_logo.a1d3ec00.png";